import { useNavigation, useRoute } from "@react-navigation/native";
import { AHText, useTheme, AHTextFonts, useLayoutContext } from "arkh";
import Color from "color";

import React, { useCallback, useMemo } from "react";
import { Platform, Pressable } from "react-native";
import { graphql, useFragment } from "react-relay";
import { useSizeClass } from "../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

import { PLUCategoryItemEditOverlay } from "./PLUCategoryItemEditOverlay";
import { PLUCategoryItemSpacer } from "./PLUCategoryItemSpacer";
import { PLUCategoryItem_PLUCategory$key } from "./__generated__/PLUCategoryItem_PLUCategory.graphql";
import * as Haptic from "expo-haptics";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export const PLUCategoryItem = React.memo(InnerPLUCategoryItem);
function InnerPLUCategoryItem(props: {
  index: number;
  selectedCategory: string | undefined;
  setSelectedCategory(_: string | undefined): void;
  pluCategory: PLUCategoryItem_PLUCategory$key;
}) {
  const data = useFragment(
    graphql`
      fragment PLUCategoryItem_PLUCategory on PLUCategory {
        id
        title
        color
      }
    `,
    props.pluCategory
  );

  const selected = useMemo(
    () => props.selectedCategory === data.id,
    [data.id, props.selectedCategory]
  );

  const theme = useTheme();
  const layout = useLayoutContext();
  const onPress = useCallback(
    () =>
      props.setSelectedCategory(
        data.id === props.selectedCategory ? undefined : data.id
      ),
    [data.id, props]
  );
  const {
    params: { isEditing },
  } = useRoute<UserLoggedInNavigatorRouteProp<"TeamPLU">>();
  const navigation =
    useNavigation<UserLoggedInNavigatorNavigationProp<"TeamPLU">>();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const onPressIn = useCallback(() => {
    if (Platform.OS === "ios") {
      Haptic.selectionAsync();
    }
  }, []);

  const selectedColor = useMemo(
    () => Color(data.color).lightness(90).toString(),
    [data.color]
  );

  return (
    <PLUCategoryItemSpacer>
      <Pressable
        style={(p) => ({
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: selected
            ? p.pressed
              ? selectedColor
              : data.color
            : p.pressed
              ? selectedColor
              : theme.background,
          borderLeftWidth: layout.space.medium,
          borderColor: data.color,
          paddingHorizontal: layout.space.xsmall,
          borderRadius: layout.radius.medium,
        })}
        onPressIn={onPressIn}
        onPress={onPress}
      >
        <AHText
          type="title"
          numberOfLines={2}
          font={selected ? AHTextFonts.BOLDER : AHTextFonts.MEDIUM}
          style={{
            flex: 1,
            fontSize: isCompact ? 15 : 18,
            color: selected ? theme.surface : theme.darkerText,
          }}
        >
          {data.title}
        </AHText>
        {isEditing ? (
          <PLUCategoryItemEditOverlay
            onPress={() => {
              navigation.navigateDeprecated("PLUCategoryEdit", { id: data.id });
            }}
          />
        ) : null}
      </Pressable>
    </PLUCategoryItemSpacer>
  );
}
